'use client';

import Bugsnag from '@bugsnag/js';
// eslint-disable-next-line @alltrails/custom/react-imports
import React, { PropsWithChildren, useMemo } from 'react';

// @ts-expect-error prevent "Bugsnag.getPlugin() was called before Bugsnag.start()" errors in tests
const plugin = Bugsnag._client ? Bugsnag.getPlugin('react') : null;
const BugsnagErrorBoundary = plugin?.createErrorBoundary(React);

type ErrorBoundaryProps = {
  fallback?: React.ReactElement;
};

const ErrorBoundary = ({ children, fallback }: PropsWithChildren<ErrorBoundaryProps>) => {
  const bugsnagFallback = useMemo(() => () => <>{fallback}</>, [fallback]);

  if (BugsnagErrorBoundary) {
    return <BugsnagErrorBoundary FallbackComponent={bugsnagFallback}>{children}</BugsnagErrorBoundary>;
  }

  return <>{children}</>;
};

export default ErrorBoundary;
